(function(){
  var CID='UvkbNh',REV='2025-07-15',BASE='https://a.klaviyo.com/client/';
  function $(i){return document.getElementById(i);}
  function kl(path,payload){try{return fetch(BASE+path+'/?company_id='+CID,{method:'POST',headers:{'Content-Type':'application/json',revision:REV},body:JSON.stringify(payload),keepalive:true}).catch(function(){});}catch(e){}}
  function validEmail(v){var a=v.indexOf('@');return a>0&&v.indexOf(' ')<0&&v.indexOf('.',a)>a+1&&v.charAt(v.length-1)!=='.';}
  var AN=window.AN=window.AN||{};
  AN.validEmail=validEmail;
  AN.upsert=function(attrs){return kl('profiles',{data:{type:'profile',attributes:attrs}});};
  AN.subscribe=function(email,listId,source){return kl('subscriptions',{data:{type:'subscription',attributes:{custom_source:source,profile:{data:{type:'profile',attributes:{email:email}}}},relationships:{list:{data:{type:'list',id:listId}}}}});};
  AN.track=function(name,pa,props){return kl('events',{data:{type:'event',attributes:{properties:props||{},metric:{data:{type:'metric',attributes:{name:name}}},profile:{data:{type:'profile',attributes:pa}}}}});};

  /* ---------- bag ---------- */
  function money(c){return '$'+(c/100).toFixed(2).replace(/\.00$/,'');}
  function esc(x){return String(x==null?'':x).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function openBag(){ $('scrim').hidden=false; $('drawer').hidden=false; }
  function closeBag(){ $('scrim').hidden=true; $('drawer').hidden=true; }
  AN.drawBag=function(){
    return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      $('bag-n').textContent=c.item_count;
      $('lines').innerHTML=c.items.map(function(it){
        var p=it.properties||{}, g=p['Gift for']?'<p class="g">Gift for '+esc(p['Gift for'])+(p['Email sends']?' · your message emails '+esc(p['Email sends']):'')+'</p>':'';
        return '<div class="line"><div class="lph"><img src="'+esc(it.image)+'" alt=""></div><div><div class="n">'+esc(it.product_title)+'</div><div>'+money(it.final_line_price)+(it.quantity>1?' · Qty '+it.quantity:'')+'</div>'+g+'</div></div>';
      }).join('')||'<p class="fine">Your bag is empty.</p>';
      $('tot').textContent=money(c.total_price);
    }).catch(function(){});
  };
  AN.add=function(variantId,props){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1,properties:props||{}}]})})
      .then(function(r){return r.json();}).then(function(){return AN.drawBag();}).then(openBag);
  };
  document.addEventListener('DOMContentLoaded',function(){
    if($('bag-open')){ $('bag-open').onclick=function(){AN.drawBag();openBag();}; $('bag-x').onclick=closeBag; $('scrim').onclick=closeBag; }
    /* ---------- pop-ups: member + share your story ----------
       Timing rules live here, in one place. Change a number and re-upload this file.
       delay  = seconds on the page        scroll = how far down the page (0.5 = halfway)
       anchor = fires when this part of the page comes into view
       dwell  = seconds the anchor must stay on screen        exit = desktop exit intent */
    var RULES={
      home:        {member:{delay:20,scroll:0.5,exit:true}},
      'an-pstory': {member:{delay:45,anchor:'.srow.flip'}, share:{anchor:'#avals',dwell:15,exit:true}},
      'an-p2027':  {member:{delay:15}},
      'default':   {member:{delay:20,scroll:0.5}}
    };
    var REST_DAYS=7, T0=Date.now();
    function ls(k,v){try{if(v===undefined)return localStorage.getItem(k);if(v===null)localStorage.removeItem(k);else localStorage.setItem(k,v);}catch(e){return null;}}
    function ss(k,v){try{if(v===undefined)return sessionStorage.getItem(k);sessionStorage.setItem(k,v);}catch(e){return null;}}
    /* team visits: open adinkranova.com/?team=1 once per device to leave your own visits out of tracking (?team=0 undoes it) */
    (function(){var m=location.search.match(/[?&]team=([01])/);if(m)ls('an_team',m[1]==='1'?'1':null);})();
    var TEAM=ls('an_team')==='1';
    function secs(){return Math.round((Date.now()-T0)/1000);}
    function log(name,id,trigger){var d={popup:id,trigger:trigger||'click',page:location.pathname,seconds_on_page:secs(),team:TEAM};
      try{if(!TEAM&&window.Shopify&&Shopify.analytics&&Shopify.analytics.publish)Shopify.analytics.publish('adinkranova_'+name,d);}catch(e){}
      return d;}
    function state(id){var v=ls('an_pop_'+id);if(!v&&id==='member'){var o=ls('an_member_pop_v1');if(o==='joined')return {s:'done'};if(o)return {s:'closed',t:Number(o)||0};}
      try{return v?JSON.parse(v):null;}catch(e){return null;}}
    function setState(id,s){ls('an_pop_'+id,JSON.stringify({s:s,t:Date.now()}));if(id==='member'&&s==='done')ls('an_member_pop_v1','joined');}
    function resting(id){var st=state(id);if(!st)return false;if(st.s==='done')return true;return Date.now()-(st.t||0)<REST_DAYS*864e5;}
    function anyOpen(){return [].some.call(document.querySelectorAll('.an .pop'),function(p){return !p.hidden;})||($('drawer')&&!$('drawer').hidden);}

    var POPS={};
    function makePop(id,el,focusId,onOpen){
      if(!el)return null;var last=null,cur='click';
      var P={id:id,el:el,trigger:function(){return cur;},
        open:function(e,trigger){if(e&&e.preventDefault)e.preventDefault();last=e&&e.currentTarget;cur=trigger||'click';if(onOpen)onOpen();el.hidden=false;log('popup_shown',id,cur);setTimeout(function(){var f=$(focusId);if(f)f.focus();},30);},
        close:function(){if(el.hidden)return;el.hidden=true;if(state(id)?state(id).s!=='done':true)setState(id,'closed');log('popup_closed',id,cur);if(last&&last.focus)last.focus();}};
      el.addEventListener('click',function(e){if(e.target===el)P.close();});
      POPS[id]=P;return P;}

    var member=makePop('member',$('pop'),'p-name',function(){var ok=$('pop-ok');if(ok)ok.hidden=true;});
    if(member){
      AN.openPop=function(e){member.open(e,'click');};
      [].forEach.call(document.querySelectorAll('.open-pop'),function(b){b.addEventListener('click',AN.openPop);});
      $('pop-x').onclick=member.close;
      $('pop-form').addEventListener('submit',function(e){
        e.preventDefault();
        var name=$('p-name').value.trim(), email=$('p-email').value.trim(), ex=$('p-excited').value.trim();
        if(email && !validEmail(email)){ $('p-email').focus(); return; }
        if(email){
          var d=log('popup_submitted','member',member.trigger());
          AN.upsert({email:email,first_name:name,properties:{excited_for:ex,member_source:'member_popup',member_signup_page:location.pathname}});
          AN.subscribe(email,'Y7XcsZ','AdinkraNova Member Pop-up');
          AN.track('Became AdinkraNova Member',{email:email,first_name:name},{excited_for:ex,page:d.page,trigger:d.trigger,seconds_on_page:d.seconds_on_page,team_visit:TEAM});
          setState('member','done');
        }
        $('pop-ok').hidden=false;
        setTimeout(function(){member.el.hidden=true;},2200);
      });
    }

    var share=makePop('share',$('spop'),'s-story');
    if(share){
      [].forEach.call(document.querySelectorAll('.open-share'),function(b){b.addEventListener('click',function(e){share.open(e,'click');});});
      $('s-x').onclick=share.close; if($('s-done'))$('s-done').onclick=function(){share.el.hidden=true;};
      var ta=$('s-story'),cn=$('s-count');
      if(ta&&cn)ta.addEventListener('input',function(){cn.textContent=ta.value.length.toLocaleString()+' / 1,000 characters';cn.classList.toggle('full',ta.value.length>=1000);});
      $('s-form').addEventListener('submit',function(e){
        e.preventDefault();var err=$('s-err'),st=ta.value.trim(),em=$('s-email').value.trim(),nm=$('s-name').value.trim(),ig=$('s-ig').value.trim().replace(/^@+/,'');
        var perm=(document.querySelector('#s-form input[name=s-perm]:checked')||{}).value||'anon';
        if(st.length<5){err.textContent='Please write a few words about your story.';ta.focus();return;}
        if(!validEmail(em)){err.textContent='Please add your email so we can thank you.';$('s-email').focus();return;}
        if(perm==='name'&&!nm){err.textContent='Add your first name, or choose “Yes, anonymously”.';$('s-name').focus();return;}
        err.textContent='';
        var d=log('popup_submitted','share',share.trigger()), pa={email:em};
        if(nm)pa.first_name=nm;
        AN.upsert({email:em,first_name:nm||undefined,properties:{instagram:ig||undefined,story_shared:true}});
        AN.track('Shared a Story',pa,{story:st,share_permission:perm,first_name:nm,instagram:ig,page:d.page,trigger:d.trigger,seconds_on_page:d.seconds_on_page,team_visit:TEAM});
        setState('share','done');
        $('s-form').hidden=true;$('s-ok').hidden=false;
      });
    }

    document.addEventListener('keydown',function(e){if(e.key==='Escape'){ for(var k in POPS){if(!POPS[k].el.hidden)POPS[k].close();} if($('drawer')&&!$('drawer').hidden)closeBag(); }});

    /* automatic opening: one automatic pop-up per visit, rested 7 days after closing, never after joining or sharing */
    if(document.body.getAttribute('data-an-autopop')!=='off'){
      var wrap=document.querySelector('.an'), key='default';
      if(location.pathname==='/'||location.pathname==='')key='home';
      else if(wrap){for(var c in RULES){if(c!=='home'&&c!=='default'&&wrap.classList.contains(c)){key=c;break;}}}
      var rules=RULES[key]||{};
      Object.keys(rules).forEach(function(id){
        var P=POPS[id],r=rules[id];if(!P||resting(id))return;var fired=false;
        function fire(trigger){if(fired||ss('an_auto')==='1')return;if(anyOpen()){setTimeout(function(){fire(trigger);},4000);return;}fired=true;ss('an_auto','1');P.open(null,trigger);}
        if(r.delay)setTimeout(function(){fire('time_'+r.delay+'s');},r.delay*1000);
        if(r.scroll){var onS=function(e){var el=(e&&e.target&&e.target.nodeType===1)?e.target:(document.scrollingElement||document.documentElement);var h=el.scrollHeight-el.clientHeight;if(h>200&&el.scrollTop/h>=r.scroll){document.removeEventListener('scroll',onS,true);fire('scroll_'+Math.round(r.scroll*100)+'pct');}};document.addEventListener('scroll',onS,{capture:true,passive:true});}
        var a=r.anchor&&document.querySelector(r.anchor);
        if(a&&'IntersectionObserver' in window){var tm=null;
          new IntersectionObserver(function(en){en.forEach(function(x){
            if(r.dwell){if(x.isIntersecting){if(!tm)tm=setTimeout(function(){fire('dwell_'+r.dwell+'s');},r.dwell*1000);}else{clearTimeout(tm);tm=null;}}
            else if(x.isIntersecting)fire('reached_section');});},{threshold:r.dwell?0.35:0.01}).observe(a);}
        if(r.exit&&matchMedia('(pointer:fine)').matches){document.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<=0&&secs()>5)fire('exit_intent');});}
      });
    }
  });
})();

/* keep every AdinkraNova video silent and looping, no prompt needed */
(function(){
  function keep(v){
    v.muted=true;v.defaultMuted=true;v.volume=0;v.setAttribute('muted','');
    v.loop=true;v.autoplay=true;v.playsInline=true;v.setAttribute('playsinline','');v.setAttribute('webkit-playsinline','');
    v.removeAttribute('controls');
    function play(){try{var r=v.play();if(r&&r.catch)r.catch(function(){});}catch(e){}}
    v.addEventListener('volumechange',function(){if(!v.muted||v.volume>0){v.muted=true;v.volume=0;}});
    v.addEventListener('ended',function(){v.currentTime=0;play();});
    v.addEventListener('pause',function(){if(!document.hidden)setTimeout(play,60);});
    v.addEventListener('canplay',play);
    document.addEventListener('visibilitychange',function(){if(!document.hidden)play();});
    ['touchstart','click','scroll','keydown'].forEach(function(t){window.addEventListener(t,play,{once:true,passive:true});});
    play();
  }
  function run(){[].forEach.call(document.querySelectorAll('.an video'),keep);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
